import axios from 'axios';
import { endpoints } from './use-api';

export const loadUserAppProfile = async (_cognitoUser: any) => {
  const response = await axios.get(endpoints.entity.user.loadProfile());
  return response.data;
}

